































































import { Component, Prop, Vue, Watch, Mixins } from 'vue-property-decorator'
import listMixins from '@/mixins/list'
import { columns } from './config'
import TaskApi from '@/api/task'
import bus from './bus'

@Component({})
export default class RelationsOrders extends Mixins(listMixins) {
	private columns: object = columns
	private relationOrders: any = []

	@Prop()
	private activeKey!: any

	public async getList() {
		const res = await TaskApi.getRelationOrders({
			orderId: this.$route.params.orderId,
			pageSize: this.pageSize,
			pageNum: this.current,
		})

		const data = res.data
		this.total = data.count
		this.relationOrders = data.retList
	}

	public created() {
		this.getList()
		bus.$on('addTask', () => {
			if (this.$route.params.orderId) {
				this.getList()
			}
		})
	}

	public activated() {
		if (this.$route.params.orderId) {
			this.getList()
		}
	}

	private beforeDestroy() {
		bus.$off('addTask')
	}

	private openOrder(taskType: string, orderId: any) {
		this.$router.push(
			`/CommonAiiTask/TasksDetail/${orderId}/${taskType}`,
			() => {},
			() => {}
		) // 防报错 TODO
	}
}
